export const syncStatusOptions = {
  DETECTED_CONFLICT: "DETECTED_CONFLICT",
  DETECTED_CHANGE_IN_LOCAL: "DETECTED_CHANGE_IN_LOCAL",
  DETECTED_CHANGE_IN_EXTERNAL: "DETECTED_CHANGE_IN_EXTERNAL",
  DETECTED_CHANGE_IN_BOTH: "DETECTED_CHANGE_IN_BOTH",
  DETECTED_DELETE_IN_LOCAL: "DETECTED_DELETE_IN_LOCAL",
  DETECTED_DELETE_IN_EXTERNAL: "DETECTED_DELETE_IN_EXTERNAL",
  DETECTED_CREATE_IN_LOCAL: "DETECTED_CREATE_IN_LOCAL",
  DETECTED_CREATE_IN_EXTERNAL: "DETECTED_CREATE_IN_EXTERNAL",
  DETECTED_MOVE_IN_LOCAL: "DETECTED_MOVE_IN_LOCAL",
  DETECTED_MOVE_IN_EXTERNAL: "DETECTED_MOVE_IN_EXTERNAL",
  DETECTED_NO_CHANGE: "DETECTED_NO_CHANGE",
  DETECTED_IGNORE: "DETECTED_IGNORE"
};

export const syncStatusSeverity = {
  DETECTED_CONFLICT: 10,
  DETECTED_DELETE_IN_LOCAL: 9,
  DETECTED_DELETE_IN_EXTERNAL: 8,
  DETECTED_CREATE_IN_LOCAL: 7,
  DETECTED_CREATE_IN_EXTERNAL: 6,
  DETECTED_MOVE_IN_LOCAL: 5,
  DETECTED_MOVE_IN_EXTERNAL: 4,
  DETECTED_CHANGE_IN_BOTH: 3,
  DETECTED_CHANGE_IN_LOCAL: 2,
  DETECTED_CHANGE_IN_EXTERNAL: 1,
  DETECTED_NO_CHANGE: 0,
  DETECTED_IGNORE: -1
};

export const syncStatusLowestSeverity = syncStatusOptions.DETECTED_IGNORE;

export const syncStatusProperties = {
  DETECTED_CONFLICT: {
    status: syncStatusOptions.DETECTED_CONFLICT,
    statusIcon: "statusConflict",
    statusColor: "statusError",
    iconColor: "iconMono",
    labelColor: "statusErrorLabel",
    statusLabel: "Conflict"
  },
  DETECTED_CHANGE_IN_LOCAL: {
    status: syncStatusOptions.DETECTED_CHANGE_IN_LOCAL,
    statusIcon: "statusWarning",
    statusColor: "statusWarn",
    iconColor: "iconMono",
    labelColor: "statusWarnLabel",
    statusLabel: "Changed in timeline"
  },
  DETECTED_CHANGE_IN_EXTERNAL: {
    status: syncStatusOptions.DETECTED_CHANGE_IN_EXTERNAL,
    statusIcon: "statusWarning",
    statusColor: "statusWarn",
    iconColor: "iconMono",
    labelColor: "statusWarnLabel",
    statusLabel: "Changed in project"
  },
  DETECTED_CHANGE_IN_BOTH: {
    status: syncStatusOptions.DETECTED_CHANGE_IN_BOTH,
    statusIcon: "statusWarning",
    statusColor: "statusWarn",
    iconColor: "iconMono",
    labelColor: "statusWarnLabel",
    statusLabel: "Changed in both"
  },
  DETECTED_DELETE_IN_LOCAL: {
    status: syncStatusOptions.DETECTED_DELETE_IN_LOCAL,
    statusIcon: "statusDeleted",
    statusColor: "statusWarn",
    iconColor: "iconMono",
    labelColor: "statusWarnLabel",
    statusLabel: "Deleted from timeline"
  },
  DETECTED_DELETE_IN_EXTERNAL: {
    status: syncStatusOptions.DETECTED_DELETE_IN_EXTERNAL,
    statusIcon: "statusDeleted",
    statusColor: "statusWarn",
    iconColor: "iconMid",
    labelColor: "statusWarnLabel",
    statusLabel: "Deleted from project"
  },
  DETECTED_CREATE_IN_LOCAL: {
    status: syncStatusOptions.DETECTED_CREATE_IN_LOCAL,
    statusIcon: "statusAdded",
    statusColor: "statusAdded",
    iconColor: "iconMono",
    labelColor: "statusAddedLabel",
    statusLabel: "New in timeline"
  },
  DETECTED_CREATE_IN_EXTERNAL: {
    status: syncStatusOptions.DETECTED_CREATE_IN_EXTERNAL,
    statusIcon: "statusAdded",
    statusColor: "statusAdded",
    iconColor: "iconMid",
    labelColor: "statusAddedLabel",
    statusLabel: "New in project"
  },
  DETECTED_MOVE_IN_LOCAL: {
    status: syncStatusOptions.DETECTED_MOVE_IN_LOCAL,
    statusIcon: "statusOpen",
    statusColor: "statusWarn",
    iconColor: "iconMono",
    labelColor: "statusWarnLabel",
    statusLabel: "Moved to new location"
  },
  DETECTED_MOVE_IN_EXTERNAL: {
    status: syncStatusOptions.DETECTED_MOVE_IN_EXTERNAL,
    statusIcon: "statusOpen",
    statusColor: "statusWarn",
    iconColor: "iconMono",
    labelColor: "statusWarnLabel",
    statusLabel: "Moved to new location"
  },
  DETECTED_NO_CHANGE: {
    status: syncStatusOptions.DETECTED_NO_CHANGE,
    statusIcon: null,
    statusColor: null,
    iconColor: "iconMono",
    labelColor: "iconMono",
    statusLabel: "No changes"
  },
  DETECTED_IGNORE: {
    status: syncStatusOptions.DETECTED_IGNORE,
    statusIcon: "statusIgnore",
    statusColor: "statusUnknown",
    iconColor: "statusUnknown",
    labelColor: "statusUnknown",
    statusLabel: "Ignored during sync"
  }
};
